import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';

import {
  AcademicAppointment,
  displayTime,
} from '../../../../../core/interfaces/academic-appointment';

/**
 * Encart d'appel à l'action du tableau de bord primaire.
 *
 * Quand une séance est réellement programmée, la carte l'annonce ; sinon elle
 * retombe sur une invitation à s'entraîner. Aucune « quête » n'est inventée :
 * le produit n'en gère pas.
 */
@Component({
  selector: 'app-prim-quest-card',
  standalone: true,
  imports: [CommonModule, RouterModule, TranslateModule],
  templateUrl: './prim-quest-card.component.html',
  styleUrl: './prim-quest-card.component.css',
})
export class PrimQuestCardComponent {
  /** Prochaine séance de l'élève, si elle existe. */
  @Input() nextSession: AcademicAppointment | null = null;

  /** Le test diagnostique est l'entrée naturelle du module. */
  @Input() ctaLink = '/student/tests/diagnostic';

  /** Destination quand une séance est annoncée. */
  @Input() agendaLink = '/student/agenda';

  get hasSession(): boolean {
    return !!this.nextSession;
  }

  get sessionTime(): string {
    return displayTime(this.nextSession?.startTime);
  }
}
